import React, { useEffect, useState } from "react";
import style from "./Addchat.module.css";
import { MdAddComment } from "react-icons/md";
import {
  arrayUnion,
  collection,
  doc,
  getDocs,
  onSnapshot,
  query,
  serverTimestamp,
  setDoc,
  updateDoc,
  where,
  writeBatch,
} from "firebase/firestore";
import { db, storage } from "../../firebase/config";
import { v4 as uuid } from "uuid";
import Overlayform from "./Overlay";
import Chatcard from "./Chatcard";
import { TbUserEdit } from "react-icons/tb";
import { BiSolidImageAdd } from "react-icons/bi";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
const Addchat = (props) => {
  const [rule, setRule] = useState();
  const [photo, setPhoto] = useState(
    "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/client.jpg?alt=media&token=2de615ef-95b2-4e61-933d-3572ba0f4fa5"
  );
  const [engneers, setEngineers] = useState([]);
  const [clients, setClients] = useState([]);
  const [supervisor, setSupervisor] = useState([]);
  const [support, setSupport] = useState([]);
  const [admin, setAdmin] = useState([]);
  const sortedengineers = Object.entries(engneers);
  const sortedclients = Object.entries(clients);
  const sortedsupervisor = Object.entries(supervisor);
  const sortedsupport = Object.entries(support);
  const sortedadmin = Object.entries(admin);
  const [userarray, setUserarray] = useState([]);
  const [overlay, setOverlay] = useState(false);
  const [overlayEdite, setOverlayEdite] = useState(false);
  const [name, setName] = useState("");
  const [date, setDate] = useState("");
  const [displayname, setDisplayname] = useState("");
  const [user, setUser] = useState({});
  const [newName, setNewName] = useState(null);
  const [roomService,setRoomService]=useState(false)

  const adminAccount = [
    {
      un_read_message: 0,
      user_id: "29CxFIUNsQZtv7pk4SBZuRAHxJC3",
    },
  ];
  useEffect(() => {
    const q = query(collection(db, "users"), where("rule", "==", "client"));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const demo = [];
      querySnapshot.forEach((doc) => {
        demo.push(doc.data());
      });
      setClients(demo);
    });
    const qq = query(collection(db, "users"), where("rule", "==", "engineer"));
    const unnsubscribe = onSnapshot(qq, (querySnapshot) => {
      const demo = [];
      querySnapshot.forEach((doc) => {
        demo.push(doc.data());
      });
      setEngineers(demo);
    });
    const qqq = query(
      collection(db, "users"),
      where("rule", "==", "supervisor")
    );
    const unnnsubscribe = onSnapshot(qqq, (querySnapshot) => {
      const demo = [];
      querySnapshot.forEach((doc) => {
        demo.push(doc.data());
      });
      setSupervisor(demo);
    });
    const qqqq = query(collection(db, "users"), where("rule", "==", "support"));
    const unnnnsubscribe = onSnapshot(qqqq, (querySnapshot) => {
      const demo = [];
      querySnapshot.forEach((doc) => {
        demo.push(doc.data());
      });
      setSupport(demo);
    });
    const qqqqq = query(collection(db, "users"), where("rule", "==", "admin"));
    const unnnnnsubscribe = onSnapshot(qqqqq, (querySnapshot) => {
      const demo = [];
      querySnapshot.forEach((doc) => {
        demo.push(doc.data());
      });
      setAdmin(demo);
    });
  }, []);
  useEffect(() => {
    const updatedArray = admin.map((user) => ({
      un_read_message: 0,
      user_id: user.uid,
    }));
    setUserarray((prevArray) => [...prevArray, ...updatedArray]);
  }, [admin]);
  useEffect(() => {
    {
      props.edite && setUserarray([]);
    }
  }, [props.edite]);
  const demo = [];
  const addtochat = (user) => {
    // Check if the user already exists in userArray
    const userIndex = userarray.findIndex((item) => item.user_id === user.uid);

    if (userIndex !== -1) {
      // If the user exists, remove them from userArray
      const updatedUserArray = [...userarray];
      updatedUserArray.splice(userIndex, 1);
      setUserarray(updatedUserArray);
    } else {
      // If the user doesn't exist, add them to the userArray with un_read_message set to 0
      setUserarray([...userarray, { user_id: user.uid, un_read_message: 0 }]);
    }
  };

  const createchat = async (e) => {
    e.preventDefault();
    const file = e.target[2].files[0];
    if (file !== undefined) {
      try {
        const storageRef = ref(storage, uuid());
        const uploadTask = uploadBytesResumable(storageRef, file);
        uploadTask.on(
          "state_changed",
          (snapshot) => {
            switch (snapshot.state) {
              case "paused":
                break;
              case "running":
                break;
            }
          },
          (error) => {},
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then(
              async (downloadURL) => {
                const uid = uuid();
                await setDoc(doc(db, "messages", uid), { message: [] });
                await setDoc(doc(db, "roomuser", uid), {
                  createdat: serverTimestamp(),
                  users: [],
                  imageurl: downloadURL,
                  name: name,
                  uid: uid,
                  enddate: date,
                  // users:adminAccount
                });
                updateDoc(doc(db, "roomuser", uid), {
                  users: userarray,
                });
                setUserarray([]);
                setOverlay(false);
              }
            );
          }
        );
        setName("");
        setDate("");
      } catch (error) {
        console.log(error);
      }
    } else {
      const uid = uuid();
      await setDoc(doc(db, "messages", uid), { message: [] });
      await setDoc(doc(db, "roomuser", uid), {
        createdat: serverTimestamp(),
        users: [],
        imageurl:
          "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/defaultimage.webp?alt=media&token=5dc2fd7f-e7c1-4ba9-ac27-9b340a2b2fd1",
        name: name,
        uid: uid,
        enddate: date,
        // users:adminAccount
      });
      updateDoc(doc(db, "roomuser", uid), {
        users: userarray,
      });
      setUserarray([]);
      setOverlay(false);
    }
  };
  const edite = (user) => {
    setUser(user);
    setRule(user?.rule && user?.rule)
    setRoomService(user?.callCenter && user?.callCenter)
    setOverlayEdite(true);
  };
  const updateuser = async (e) => {
    e.preventDefault();
    const file = e.target[1].files[0];
    let downloadURL = null;

    try {
      if (file !== undefined) {
        const storageRef = ref(storage, uuid());
        const uploadTask = uploadBytesResumable(storageRef, file);

        await new Promise((resolve, reject) => {
          uploadTask.on(
            "state_changed",
            (snapshot) => {
              // Handle progress (optional)
            },
            (error) => {
              reject(error);
            },
            async () => {
              downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
              resolve();
            }
          );
        });
      }

      const userDocRef = doc(db, "users", user.uid);
      await updateDoc(userDocRef, {
        displayname: newName !== null ? newName : user.displayname,
        photoURL: downloadURL !== null ? downloadURL : user.photoURL,
        rule: rule,
        callCenter:roomService
      });

      if (rule === "admin") {
        const roomuserCollectionRef = collection(db, "roomuser");
        const roomuserSnapshot = await getDocs(roomuserCollectionRef);
        const batch = writeBatch(db);

        roomuserSnapshot.forEach((doc) => {
          const docRef = doc.ref;
          batch.update(docRef, {
            users: arrayUnion({
              un_read_message: 0,
              user_id: user.uid,
            }),
          });
        });

        await batch.commit();
      }

      setNewName(null);
      setOverlayEdite(false);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={style.addchatcontainer}>
      {overlay && (
        <Overlayform>
          <form onSubmit={createchat} className={style.addchatform}>
            <h2 onClick={() => setOverlay(false)}>X</h2>
            <h2>من فضلك يرجي اكمال البيانات التاليه ل اكمال انشاء الشات</h2>
            <div className={style.input}>
              <TbUserEdit size={25} color="#999" />
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="اسم الشات"
              />
            </div>
            <div className={style.input}>
              <input type="date" onChange={(e) => setDate(e.target.value)} />
            </div>
            <input type="file" style={{ display: "none" }} id="file" />
            <label className={style.avatar} htmlFor="file">
              <BiSolidImageAdd size={50} />
              <span>add avatar</span>
            </label>
            <button type="submit">انشاء الشات</button>
          </form>
        </Overlayform>
      )}
      {overlayEdite && (
        <Overlayform>
          <form onSubmit={updateuser} className={style.addchatform}>
            <h2 onClick={() => setOverlayEdite(false)}>X</h2>
            <div className={style.input}>
              <TbUserEdit size={25} color="#999" />
              <input
                type="text"
                value={newName}
                onChange={(e) => setNewName(e.target.value)}
                placeholder="تعديل اسم الشخص"
              />
            </div>
            <input type="file" style={{ display: "none" }} id="file" />
            <label className={style.avatar} htmlFor="file">
              <BiSolidImageAdd size={50} />
              <span>add avatar</span>
            </label>
            <div className={style.ratiocontainer}>
              <div className={style.ratiocard}>
                <div
                  onClick={() => {
                    setRule("engineer");
                    setPhoto(
                      "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/engineer.png?alt=media&token=a5fbbb81-b7f2-470e-930d-3a50078fa47e"
                    );
                  }}
                  style={{
                    backgroundColor: rule === "engineer" ? "#605F5F" : "",
                  }}
                  className={style.ratio}></div>
                <p>مهندس</p>
              </div>
              <div className={style.ratiocard}>
                <div
                  onClick={() => {
                    setRule("client");
                  }}
                  style={{
                    backgroundColor: rule === "client" ? "#605F5F" : "",
                  }}
                  className={style.ratio}></div>
                <p>عميل</p>
              </div>
              <div className={style.ratiocard}>
                <div
                  onClick={() => {
                    setRule("supervisor");
                    setPhoto(
                      "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/supervisor.jpg?alt=media&token=7ec478a4-d848-4a42-afb7-7e98615c273b"
                    );
                  }}
                  style={{
                    backgroundColor: rule === "supervisor" ? "#605F5F" : "",
                  }}
                  className={style.ratio}></div>
                <p>مشرف</p>
              </div>
              <div className={style.ratiocard}>
                <div
                  onClick={() => {
                    setRule("support");
                    setPhoto(
                      "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/support.jpg?alt=media&token=4317a873-b97e-4854-8b1d-75c5f61102f1"
                    );
                  }}
                  style={{
                    backgroundColor: rule === "support" ? "#605F5F" : "",
                  }}
                  className={style.ratio}></div>
                <p>دعم </p>
              </div>
              <div className={style.ratiocard}>
                <div
                  onClick={() => {
                    setRule("admin");
                    setPhoto(
                      "https://firebasestorage.googleapis.com/v0/b/arch-chat-ec653.appspot.com/o/admin.jpg?alt=media&token=5a00a2d3-88b7-4a27-a898-6eed161a4fe7"
                    );
                  }}
                  style={{ backgroundColor: rule === "admin" ? "#605F5F" : "" }}
                  className={style.ratio}></div>
                <p>مدير</p>
              </div>
              <div className={style.ratiocontainer}>
                <div className={style.ratiocard}>
                  <div
                    onClick={() => {
                      setRoomService(!roomService);
                    }}
                    style={{
                      backgroundColor: roomService === true ? "#605F5F" : "",
                    }}
                    className={style.ratio}></div>
                  <p>خدمه عملاء</p>
                </div>
              </div>
            </div>
            <button type="submit">تعديل البيانات</button>
          </form>
        </Overlayform>
      )}
      <div className={style.addchatnav}>
        <p>جميع الاعضاء المتاحين</p>
        <MdAddComment size={48} />
      </div>
      <div className={style.memberbox}>
        <h2>العملاء</h2>
        <div className={style.engineer}>
          {sortedclients.map((client) => {
            return (
              <Chatcard
                key={client.uid}
                addtochat={props.edite === false ? addtochat : edite}
                userarray={userarray}
                client={client[1]}
              />
            );
          })}
        </div>
        <hr />
        <h2>المهندسين</h2>
        <div className={style.engineer}>
          {sortedengineers.map((engneer) => {
            return (
              <Chatcard
                key={engneer.uid}
                addtochat={props.edite === false ? addtochat : edite}
                userarray={userarray}
                client={engneer[1]}
              />
            );
          })}
        </div>
        <hr />
        <h2>المشرفين</h2>
        <div className={style.engineer}>
          {sortedsupervisor.map((engneer) => {
            return (
              <Chatcard
                key={engneer.uid}
                addtochat={props.edite === false ? addtochat : edite}
                userarray={userarray}
                client={engneer[1]}
              />
            );
          })}
        </div>
        <hr />
        <h2>الدعم الفني</h2>
        <div className={style.engineer}>
          {sortedsupport.map((engneer) => {
            return (
              <Chatcard
                key={engneer.uid}
                addtochat={props.edite === false ? addtochat : edite}
                userarray={userarray}
                client={engneer[1]}
              />
            );
          })}
        </div>
        <hr />
        <h2>الادمن</h2>
        <div className={style.engineer}>
          {sortedadmin.map((engneer) => {
            return (
              <Chatcard
                key={engneer.uid}
                addtochat={props.edite === false ? addtochat : edite}
                userarray={userarray}
                client={engneer[1]}
              />
            );
          })}
        </div>
      </div>
      {!props.edite && (
        <div className={style.creatinginfo}>
          <button onClick={() => setOverlay(true)}>اضافة مجموعة </button>
        </div>
      )}
    </div>
  );
};
export default Addchat;
